import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageDrawer } from './LanguageDrawer';
import { LanguageFlag } from '../assets/Flags';
import { cn } from '../lib/utils';
import { APP_LANGUAGES, type AppLanguage, readAppLanguage } from '../lib/useChangeLanguage';
import { impactOccuer } from '../utils/hapticEvents';

/** Подпись языка в закрытой пилюле — как в макете: «Ру», а не «RU». */
const LANGUAGE_BADGE: Record<AppLanguage, string> = {
  ru: 'Ру',
  uz: 'Uz',
  en: 'En',
};

/**
 * Переключатель языка в шапке — рядом с поиском.
 *
 * Закрытое состояние: белая пилюля из макета, флаг и короткая подпись.
 * По тапу — та же шторка выбора языка, что в настройках: всё в приложении
 * открывается снизу, и всплывающее меню здесь смотрелось бы чужим. Отличие
 * от настроек одно — язык применяется сразу по тапу, без «Сохранить».
 */
export const LanguageSwitcher = ({ className }: { className?: string }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  // i18n — источник истины для текущего языка на экране; localStorage —
  // запасной, пока i18n не инициализировался.
  const current = ((APP_LANGUAGES as readonly string[]).includes(i18n.language)
    ? i18n.language
    : readAppLanguage()) as AppLanguage;
  const badge = LANGUAGE_BADGE[current];

  return (
    <>
      <button
        type="button"
        aria-label={i18n.t('language')}
        onClick={() => {
          impactOccuer('soft');
          setOpen(true);
        }}
        // Как кнопка поиска рядом: белая, r12, 36px на светлой шапке.
        className={cn(
          'flex h-9 shrink-0 items-center gap-2 rounded-xl bg-white px-3',
          className
        )}
      >
        <LanguageFlag language={current} className="h-4 w-5 shrink-0" />
        <span className="text-body-base-semibold text-text-primary">{badge}</span>
      </button>
      <LanguageDrawer open={open} setOpen={setOpen} applyOnSelect />
    </>
  );
};
